import {
    FETCH_TENANT_FINANCES_SUCCESS_ACTION,
    FETCH_TENANT_FINANCES_ERROR_ACTION,
    FETCH_TENANT_TRANSACTIONS_SUCCESS_ACTION,
    FETCH_TENANT_TRANSACTIONS_ERROR_ACTION,
    FETCH_CURRENCY_SUCCESS_ACTION
} from '../actions/financesActions';

export const TenantBalancesReducer = (state = [], action) => {
    switch (action.type) {
        case FETCH_TENANT_FINANCES_SUCCESS_ACTION:
            const Finances = action.payload;
            return Finances;
        case FETCH_TENANT_FINANCES_ERROR_ACTION:
            const finances = {};
            return finances;
        default:
            return state;
    }
}

export const TenantTransactionsReducer = (state = [], action) => {
    switch (action.type) {
        case FETCH_TENANT_TRANSACTIONS_SUCCESS_ACTION:
            const Transactions = action.payload;
            return Transactions;
        case FETCH_TENANT_TRANSACTIONS_ERROR_ACTION:
            const transactions = {};
            return transactions;
        default:
            return state;
    }
}

export const CurrenciesReducer = (state = [], action) => {
    switch (action.type) {
        case FETCH_CURRENCY_SUCCESS_ACTION:
            const currencies = action.payload;
            return currencies;
        default:
            return state;
    }
}